import { register } from "@shopify/theme-sections";

register("collection-filter", {
  closeAccordions() {
    document
      .querySelectorAll(".collection-filter__details-desktop")
      .forEach((detail, closeDetail, details) => {
        detail.ontoggle = (closeDetail) => {
          if (detail.open)
            details.forEach((detailSingle) => {
              if (detailSingle != detail) detailSingle.open = false;
            });
        };
      });
  },

  mobileFilterHandler() {
    const filterContainer = document.querySelector(
      ".collection-filter__mobile"
    );
    const filterClose = document.querySelector(
      ".collection-filter__mobile-close"
    );
    const filterOpen = document.querySelector(
      ".collection-filter__mobile-trigger"
    );
    const filterOverlay = document.querySelector(
      ".collection-filter__mobile-overlay"
    );

    filterOpen.onclick = function () {
      filterContainer?.classList.toggle("active");
      filterOverlay?.classList.toggle("active");
      document.querySelector("body")?.classList?.add("disable-scroll");
    };
    filterClose.onclick = function () {
      filterContainer?.classList.remove("active");
      filterOverlay?.classList.remove("active");
      document.querySelector("body")?.classList?.remove("disable-scroll");
    };
    filterOverlay.onclick = function () {
      filterContainer?.classList.remove("active");
      filterOverlay?.classList.remove("active");
      document.querySelector("body")?.classList?.remove("disable-scroll");
    };
  },

  filterSticky() {
    const filterRow = document.querySelector("[data-collection-filter]");
    const rect = filterRow.getBoundingClientRect();

    function addClassFilterRow() {
      filterRow.classList.add("fixed");
    }

    function removeClassFilterRow() {
      filterRow.classList.remove("fixed");
    }

    window.addEventListener("scroll", function () {
      let getScrollposition = window.scrollY;
      let activeSubMenu = document.querySelector(
        ".header--list-menu .active .header--submenu"
      );
      let activeWeather = document.querySelector(
        ".header--icon__weather.active .header__weather"
      );
      if (getScrollposition > rect.y) {
        addClassFilterRow();
        if (activeSubMenu || activeWeather) {
          let activeSub = activeSubMenu ? activeSubMenu : activeWeather;
          activeSub.style.top = "68px";
          activeSub.style.height = `calc(100vh - 68px)`;
        }
      } else {
        if (activeSubMenu || activeWeather) {
          let activeSub = activeSubMenu ? activeSubMenu : activeWeather;
          let transitTop = 110 - (42 / 110) * getScrollposition;
          activeSub.style.top = `${transitTop}px`;
          activeSub.style.height = `calc(100vh - ${transitTop}px)`;
        }
        removeClassFilterRow();
      }
    });
  },

  onLoad: function (e) {
    this.closeAccordions();
    this.mobileFilterHandler();
    this.filterSticky();
  },
});
